import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bcbb8cb6&scoped=true&style=height%3A%20100%25%3B&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bcbb8cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbb8cb6",
  null
  
)

export default component.exports